












































































































































































































































































































































































































































































































































































































































import MarketSelect from '@/components/MarketSelect.vue';
import MultiSelect from '@/components/MultiSelect.vue';
import {TableHeaders} from '@/interfaces/components-data';
import {
    ConfigScheduleCalcMap,
    SelectBox,
    SelectMarket,
    StrategyOfPriceOpt,
    TaskInfoCalc
} from '@/interfaces/global-data';
import {
    GetTaskInfo,
    PackageCalcConfig,
    ScheduleCalcColumns,
    ScheduleCalcFilter,
    ScheduleIndividualConfigs,
    SchedulePeriods,
    SmallScheduleListFilter,
    TaskData,
    TaskInfoFilterType,
    UserRole,
} from '@/interfaces/server-data';
import {EventBus} from '@/mixins/event-bus';
import Http from '@/mixins/http';
import {FormatNumber} from '@/numberFormatter';
import moment from 'moment';
import {Component, Mixins} from 'vue-property-decorator';
import vSelect from '@/components/UI/vSelect.vue';
import CSelect from '@/components/UI/CoefficientSelect.vue';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import LocalData from '../mixins/local-data';
import Toast from '../mixins/toast';
import CollapseCard from "@/components/UI/CollapseCard.vue"
import Card from '@/components/UI/Card.vue';
import SwitchWithLabel from '@/components/UI/SwitchWithLabel.vue';
import AutoApprovalTab from '@/components/UI/AutoApprovalTab.vue';


@Component({
    computed: {
        moment() {
            return moment
        }
    },
        components: {
            MarketSelect,
            MultiSelect,
            vSelect,
            DatePicker,
            CollapseCard,
            Card,
            CSelect,
            SwitchWithLabel,
            AutoApprovalTab
        },
        filters: {
            formatDate: (v: any) => {
                if (v) {
                    return moment(new Date(+v)).format('YYYY-MM-DD');
                }
            },
        },
        methods: {
            replaceTxtToNumber(value) {
                if (value == null) {
                    return null
                } else {
                    return value.replace(/[^\d]/g, '').substring(0, 2);
                }
            },
            replaceCommaFormatter(value) {
                return value.replace(',', '.')
            },
        },
    })
    export default class ScheduleCalculator extends Mixins(LocalData, Toast, Http) {
        defaultFilterValue = {value: -1, label: this.$t('regular.common.all') as string};

        selectTradingFilter: SelectBox<number> = this.defaultFilterValue;
        newSelectTradingFilter: number = this.defaultFilterValue.value;

        traidingsFilterOptions: Array<SelectBox<number>> = [];

        selectCategoryFilter: SelectBox<number> = this.defaultFilterValue;
        newSelectCategoryFilter: number = this.defaultFilterValue.value;
        categoryFilterOptions: Array<SelectBox<number>> = [];

        selectGroupFilter: SelectBox<number> = this.defaultFilterValue;
        newSelectGroupFilter: number = this.defaultFilterValue.value;
        groupFilterOptions: Array<SelectBox<number>> = [];

        selectSubcategoryFilter: SelectBox<number> = this.defaultFilterValue;
        newSelectSubcategoryFilter: number = this.defaultFilterValue.value;
        subcategoryFilterOptions: Array<SelectBox<number>> = [];

        selectFormatFilter: SelectBox<number> = this.defaultFilterValue;
        newSelectFormatFilter: number = this.defaultFilterValue.value;
        formatFilterOptions: Array<SelectBox<number>> = [];

        selectRegionFilter: SelectBox<number> = this.defaultFilterValue;
        newSelectRegionFilter: number = this.defaultFilterValue.value;
        regionFilterOptions: Array<SelectBox<number>> = [];

        selectClusterFilter: SelectBox<number> = this.defaultFilterValue;
        newSelectClusterFilter: number = this.defaultFilterValue.value;
        clusterFilterOptions: Array<SelectBox<number>> = [];

        defaultIntSelectBox: Array<SelectBox<number>> = [{value: 0, label: this.$t('regular.common.all') as string}];
        taskInfo: TaskInfoCalc = {
            storeFormatOptions: [],
            storeRegionOptions: [],
            buyerSegmentOptions: [],
            categoryOptions: [],
            clusterOptions: [],
            groupsOfProduct: [],
            subcategories: [],
            subcategoriesDefault: [],
            psegemnts: [],
        };
        errors = [];
        tableKey = 1;
        searchable: boolean = true;
        selectSchedulePeriod: SelectBox<SchedulePeriods> = {value: SchedulePeriods.NO_REPEAT, label: this.$t('regular.schedule.noRepeat') as string};

        scheduleCalcTableRows: ScheduleCalcColumns[] = [];

        schedulePriority: number = 1;
        scheduleTimeout: number = 24;

        scheduleCalcTableFields: TableHeaders[] = [
            {key: 'options', label: this.$t('regular.columns.actions') as string},
            {key: 'startDate', label: this.$t('regular.columns.startDate') as string},
            {key: 'endDate', label: this.$t('regular.columns.endDate') as string},
            {key: 'schedulePeriod', label: this.$t('regular.columns.frequency') as string},
            {key: 'priority', label: this.$t('regular.columns.priority') as string},
            {key: 'timeout', label: this.$t('regular.statuses.timeout') as string},
            {key: 'tradingName', label: this.$t('regular.columns.company') as string},
            {key: 'groupsOfProduct', label: this.$t('regular.columns.group') as string},
            {key: 'categories', label: this.$t('regular.columns.category') as string},
            {key: 'subcategories', label: this.$t('regular.columns.subcategory') as string},
            {key: 'storeFormat', label: this.$t('regular.columns.format') as string},
            {key: 'storeRegionValues', label: this.$t('regular.columns.region') as string},
            {key: 'storeCluster', label: this.$t('regular.columns.cluster') as string},
        ];

        newScheduleCalcTableFields: any = [
            {dataIndex: 'id', title: this.$t('regular.columns.actions') as string, scopedSlots: { customRender: 'options' }, fixed: 'left', width: 130},
            {dataIndex: 'startDate', title: this.$t('regular.columns.startDate') as string, scopedSlots: { customRender: 'startDate' }, width: 150},
            {dataIndex: 'endDate', title: this.$t('regular.columns.endDate') as string, scopedSlots: { customRender: 'endDate' }, width: 150},
            {dataIndex: 'schedulePeriod', title: this.$t('regular.columns.frequency') as string, scopedSlots: { customRender: 'schedulePeriod' }, width: 150},
            {dataIndex: 'priority', title: this.$t('regular.columns.priority') as string, scopedSlots: { customRender: 'priority' }, width: 150},
            {dataIndex: 'timeout', title: this.$t('regular.statuses.timeout') as string, scopedSlots: { customRender: 'timeout' }, width: 150},
            {dataIndex: 'tradingName', title: this.$t('regular.columns.company') as string, filters: [], scopedSlots: { filterDropdown: 'tradingFilter', filterIcon: "tradingFilterIcon" }, width: 200},
            {dataIndex: 'groupsOfProduct', title: this.$t('regular.columns.group') as string, filters: [], width: 200, scopedSlots: { filterDropdown: 'groupsFilter', filterIcon: "groupsFilterIcon" }, ellipsis: true},
            {dataIndex: 'categories', title: this.$t('regular.columns.category') as string, width: 200, filters: [], scopedSlots: { filterDropdown: 'categoriesFilter', filterIcon: "categoriesFilterIcon" }, ellipsis: true},
            {dataIndex: 'subcategories', title: this.$t('regular.columns.subcategory') as string, width: 200, filters: [], scopedSlots: { filterDropdown: 'subcategoriesFilter', filterIcon: "subcategoriesFilterIcon" }, ellipsis: true},
            {dataIndex: 'storeFormat', title: this.$t('regular.columns.format') as string, filters: [], width: 200, scopedSlots: { filterDropdown: 'storeFormatFilter', filterIcon: "storeFormatFilterIcon" }, ellipsis: true},
            {dataIndex: 'storeRegionValues', title: this.$t('regular.columns.region') as string, filters: [], width: 200, scopedSlots: { filterDropdown: 'storeRegionFilter', filterIcon: "storeRegionFilterIcon" }, ellipsis: true},
            {dataIndex: 'storeCluster', title: this.$t('regular.columns.cluster') as string, filters: [], width: 200, scopedSlots: { filterDropdown: 'storeClusterFilter', filterIcon: "storeClusterFilterIcon" }, ellipsis: true},
        ];

        pagination: any = {
            pageSize: 20,
        };

        schedulePeriodOptions: Array<SelectBox<SchedulePeriods>> = [
            {value: SchedulePeriods.NO_REPEAT, label: this.$t('regular.schedule.noRepeat') as string},
            {value: SchedulePeriods.DAY, label: this.$t('regular.schedule.daily') as string},
            {value: SchedulePeriods.WEEK, label: this.$t('regular.schedule.weekly') as string},
            {value: SchedulePeriods.MONTH, label: this.$t('regular.schedule.monthly') as string},
        ];

        scheduleCalcPerPage: number = 20;
        scheduleCalcCurrentPage: number = 1;
        scheduleCalcTotalRows: number = 0;
        calcWithScheduleCrossForModal: boolean = false;
        showBookmarks: boolean = true;
        showMainFilters: boolean = true;
        private dropDownOpen = false;
        // tslint:disable-next-line: ban-types
        private onDropdownClosed: Function | null = null;
        private individualScheduleParams: ConfigScheduleCalcMap<ScheduleIndividualConfigs> = {};
        private isScheduleCross: boolean = false;
        private responseId: number = -1;
        private needLoadFiltersForTable: boolean = true;
        private scheduleCalcId: number = -1;
        private startScheduleDate: string | null = null;
        private endScheduleDate: string | null = null;
        private scheduleCalcLimit: number = 20;
        private refreshScheduleListId = -1;
        numberFormatter = (v: any): string => FormatNumber.format(v);
        priceExperimentGenerationMethodOptions: Array<{ value: string; label: string }> = [
            { value: 'Дет-модель', label: this.$t('regular.columns.detModel') as string },
            { value: 'TS', label: 'TS' },
        ];

        mounted() {
            if (this.$scheduleCalc.selectMarket.id !== -1) {
                const self = this;
                (this.$refs.groupSelectedRef as any).toggleLoading(true);
                (this.$refs.updateRegionsRef as any).toggleLoading(true);
                (this.$refs.updateSeasonsRef as any).toggleLoading(true);
                (this.$refs.updateBuyerSegmentsRef as any).toggleLoading(true);
                (this.$refs.formatSelectedRef as any).toggleLoading(true);
                (this.$refs.clasterSelectedRef as any).toggleLoading(true);
                (this.$refs.groupOfProductRef as any).toggleLoading(true);
                (this.$refs.subcategoriesRef as any).toggleLoading(true);
                (this.$refs.productSegmentsRef as any).toggleLoading(true);
                this.getCategoryInfo();
                self.getRegionInfo();
                self.getFormatInfo();
                self.getBuyerSegment();
                self.getClusterInfo();
                self.loadProductsGroup();
                self.loadProductsSubcategories();
                self.loadProductSegments();
            }

            EventBus.$on('calc', this.onCalcEventReceived);

            const pager = { ...this.pagination };
            pager.current = 1;
            this.pagination = pager;
            this.fetchScheduleCalcList({
                currentPage: this.pagination.current
            }, () => {})
        }

        handleCancelButton(name: string, clear: any) {
            // @ts-ignore
            this[name] = -1;
            clear();
        }

        handleFilterChange(name: string, value: any) {
            // @ts-ignore
            this[name] = value;
        }

        handleFilter() {
            this.fetchScheduleCalcList({
                currentPage: this.pagination.current
            }, () => {});
        }

        handleClearFilters() {
            [
                'newSelectTradingFilter',
                'newSelectCategoryFilter',
                'newSelectGroupFilter',
                'newSelectSubcategoryFilter',
                'newSelectFormatFilter',
                'newSelectRegionFilter',
                'newSelectClusterFilter'
            ].forEach((i) => {
                // @ts-ignore
                this[i] = -1
            });

            this.fetchScheduleCalcList({
                currentPage: this.pagination.current
            }, () => {});
        }

        beforeDestroy() {
            EventBus.$off('calc', this.onCalcEventReceived);
        }

        onCalcEventReceived(data: TaskData) {
            if (this.showCalcProgress(data.status)) {
            }

        }

        refreshScheduleReports() {
            const oldRefreshId = this.refreshScheduleListId;
            if (oldRefreshId !== -1) {
                clearTimeout(oldRefreshId);
            }
            const timeoutId = setTimeout(() => {
                if (this.refreshScheduleListId === timeoutId) {
                    this.scheduleCalcCurrentPage = 1;
                    const scheduleCalc = this.$refs.scheduleCalcTableRef as any;
                    if (typeof scheduleCalc !== 'undefined') {
                        scheduleCalc.refresh();
                    }
                    this.refreshScheduleListId = -1;
                }
            }, 250);
            this.refreshScheduleListId = timeoutId;
        }

        refreshScheduleReportsBySelectedFilters() {
            this.refreshScheduleReports()
        }

        setStartDate(row: ScheduleCalcColumns): string | null {
            return row.startDate
        }

        onScheduleCalcTableChange(pagination: any) {
            const pager = { ...this.pagination };
            pager.current = pagination.current;
            this.pagination = pager;
            this.fetchScheduleCalcList({
                currentPage: pagination.current
            }, () => {});
        }

        resetData(type: TaskInfoFilterType) {
            switch (type) {
                case TaskInfoFilterType.group:
                    this.$scheduleCalc.categoriesOfProduct = [];
                    this.$scheduleCalc.subcategories = this.defaultIntSelectBox.map((i) => i.value);
                    this.$scheduleCalc.formatSelected = this.defaultIntSelectBox.map((i) => i.value);
                    this.$scheduleCalc.regionSelected = this.defaultIntSelectBox.map((i) => i.value);
                    this.$scheduleCalc.clusterSelected = this.defaultIntSelectBox.map((i) => i.value);
                    this.$scheduleCalc.productSegments = this.defaultIntSelectBox.map(i => i.value);
                    this.taskInfo.categoryOptions = [];
                    this.taskInfo.subcategories = [];
                    this.taskInfo.psegemnts = [];
                    this.taskInfo.storeFormatOptions = [];
                    this.taskInfo.storeRegionOptions = [];
                    this.taskInfo.clusterOptions = [];
                    this.getCategoryInfo(null);
                    this.loadProductsSubcategories();
                    this.loadProductSegments();
                    this.getFormatInfo();
                    this.getRegionInfo();
                    this.getClusterInfo();
                    break;
                case TaskInfoFilterType.category:
                    this.$scheduleCalc.subcategories = this.defaultIntSelectBox.map((i) => i.value);
                    this.$scheduleCalc.formatSelected = this.defaultIntSelectBox.map((i) => i.value);
                    this.$scheduleCalc.regionSelected = this.defaultIntSelectBox.map((i) => i.value);
                    this.$scheduleCalc.clusterSelected = this.defaultIntSelectBox.map((i) => i.value);
                    this.$scheduleCalc.productSegments = this.defaultIntSelectBox.map(i => i.value);
                    this.taskInfo.subcategories = [];
                    this.taskInfo.psegemnts = [];
                    this.taskInfo.storeFormatOptions = [];
                    this.taskInfo.storeRegionOptions = [];
                    this.taskInfo.clusterOptions = [];
                    this.loadProductsSubcategories();
                    this.loadProductSegments();
                    this.getFormatInfo();
                    this.getRegionInfo();
                    this.getClusterInfo();
                    break;
                case TaskInfoFilterType.subcategory:
                    this.$scheduleCalc.formatSelected = this.defaultIntSelectBox.map((i) => i.value);
                    this.$scheduleCalc.regionSelected = this.defaultIntSelectBox.map((i) => i.value);
                    this.$scheduleCalc.clusterSelected = this.defaultIntSelectBox.map((i) => i.value);
                    this.$scheduleCalc.productSegments = this.defaultIntSelectBox.map(i => i.value);
                    this.taskInfo.psegemnts = [];
                    this.taskInfo.storeFormatOptions = [];
                    this.taskInfo.storeRegionOptions = [];
                    this.taskInfo.clusterOptions = [];
                    this.loadProductSegments();
                    this.getFormatInfo();
                    this.getRegionInfo();
                    this.getClusterInfo();
                    break;
                case TaskInfoFilterType.p_segemnt:
                    this.$scheduleCalc.formatSelected = this.defaultIntSelectBox.map((i) => i.value);
                    this.$scheduleCalc.regionSelected = this.defaultIntSelectBox.map((i) => i.value);
                    this.$scheduleCalc.clusterSelected = this.defaultIntSelectBox.map((i) => i.value);
                    this.taskInfo.storeFormatOptions = [];
                    this.taskInfo.storeRegionOptions = [];
                    this.taskInfo.clusterOptions = [];
                    this.getFormatInfo();
                    this.getRegionInfo();
                    this.getClusterInfo();
                    break;
                case TaskInfoFilterType.format:
                    this.$scheduleCalc.regionSelected = this.defaultIntSelectBox.map((i) => i.value);
                    this.$scheduleCalc.clusterSelected = this.defaultIntSelectBox.map((i) => i.value);
                    this.taskInfo.storeRegionOptions = [];
                    this.taskInfo.clusterOptions = [];
                    this.loadProductSegments();
                    this.getRegionInfo();
                    this.getClusterInfo();
                    break;
                case TaskInfoFilterType.region:
                    this.$scheduleCalc.clusterSelected = this.defaultIntSelectBox.map((i) => i.value);
                    this.taskInfo.clusterOptions = [];
                    this.loadProductSegments();
                    this.getClusterInfo();
                    break;
            }
        }

        updateProductGroup(groupOfProduct: number[]) {
            if (groupOfProduct.length > 0 && !LocalData.compareTwoArrays(groupOfProduct, this.$scheduleCalc.groupsOfProduct)) {
                this.$scheduleCalc.groupsOfProduct = groupOfProduct;
                this.savePackageSchedule();
                this.resetData(TaskInfoFilterType.group);
            } else if (this.$scheduleCalc.groupsOfProduct[0] === 0) {
                this.$scheduleCalc.groupsOfProduct = this.defaultIntSelectBox.map((i) => i.value);
            }
        }

        updateProductCategory(categories: number[]) {
            if (categories.length > 0 && !LocalData.compareTwoArrays(categories, this.$scheduleCalc.categoriesOfProduct)) {
                this.$scheduleCalc.categoriesOfProduct = categories;
                this.resetData(TaskInfoFilterType.category);
                this.savePackageSchedule();
            } else if (this.$scheduleCalc.categoriesOfProduct[0] === 0) {
                this.$scheduleCalc.categoriesOfProduct = this.defaultIntSelectBox.map((i) => i.value);
            }
        }

        updateProductSegment(list: number[]) {
        if (list.length > 0 && !LocalData.compareTwoArrays(list, this.$scheduleCalc.productSegments)) {
            this.$scheduleCalc.productSegments = list;
            this.savePackageSchedule();
            this.resetData(TaskInfoFilterType.p_segemnt);
        } else if (this.$scheduleCalc.productSegments[0] === 0) {
            this.$scheduleCalc.productSegments = this.defaultIntSelectBox.map(i => i.value);
        }
    }

        updateFormats(list: number[]) {
            if (list.length > 0 && !LocalData.compareTwoArrays(list, this.$scheduleCalc.formatSelected)) {
                this.$scheduleCalc.formatSelected = list;
                this.resetData(TaskInfoFilterType.format);
                this.savePackageSchedule();
            } else if (this.$scheduleCalc.formatSelected[0] === 0) {
                this.$scheduleCalc.formatSelected = this.defaultIntSelectBox.map((i) => i.value);
            }
        }

        updateRegions(list: number[]) {
            if (list.length > 0 && !LocalData.compareTwoArrays(list, this.$scheduleCalc.regionSelected)) {
                this.$scheduleCalc.regionSelected = list;
                this.resetData(TaskInfoFilterType.region);
                this.savePackageSchedule();
            } else if (this.$scheduleCalc.regionSelected[0] === 0) {
                this.$scheduleCalc.regionSelected = this.defaultIntSelectBox.map((i) => i.value);
            }
        }

        updateClusters(list: number[]) {
            if (list.length > 0 && !LocalData.compareTwoArrays(list, this.$scheduleCalc.clusterSelected)) {
                this.$scheduleCalc.clusterSelected = list;
                this.resetData(TaskInfoFilterType.cluster);
                this.savePackageSchedule();
            } else if (this.$scheduleCalc.clusterSelected[0] === 0) {
                this.$scheduleCalc.clusterSelected = this.defaultIntSelectBox.map((i) => i.value);
            }
        }

        updateBuyerSegments(list: number[]) {
            if (list.length > 0 && !LocalData.compareTwoArrays(list, this.$scheduleCalc.buyerSegmentsList)) {
                this.$scheduleCalc.buyerSegmentsList = list;
                this.savePackageSchedule();
            } else if (this.$scheduleCalc.buyerSegmentsList[0] === 0) {
                this.$scheduleCalc.buyerSegmentsList = this.defaultIntSelectBox.map((i) => i.value);
            }
        }

        updateSubcategories(list: number[]) {
            if (list.length > 0 && !LocalData.compareTwoArrays(list, this.$scheduleCalc.subcategories)) {
                this.$scheduleCalc.subcategories = list;
                this.savePackageSchedule();
                this.resetData(TaskInfoFilterType.subcategory);
            } else if (this.$scheduleCalc.subcategories[0] === 0) {
                this.$scheduleCalc.subcategories = this.defaultIntSelectBox.map((i) => i.value);
            }
        }

        updateSeasons(list: number[]) {
            if (list.length > 0 && !LocalData.compareTwoArrays(list, this.$scheduleCalc.seasonSelected)) {
                this.$scheduleCalc.seasonSelected = list;
                this.savePackageSchedule();
            } else if (this.$scheduleCalc.seasonSelected[0] === 0) {
                this.$scheduleCalc.seasonSelected = this.defaultIntSelectBox.map((i) => i.value);
            }
        }

        updateSelectMarket(market: SelectMarket) {
            if (this.$scheduleCalc.selectMarket == null || this.$scheduleCalc.selectMarket.id !== market.id) {
                this.resetScheduleCalcData();
                this.$scheduleCalc.selectMarket = market;
                this.initTask();
                this.savePackageSchedule();
                this.$scenario.selectCoefficent = {value: {k1: 1, k2: 0, enum: StrategyOfPriceOpt.maxGrosMargin}, label: this.$t('regular.strategies.maxGrossMargin') as string}
            }
        }

        showCalcProgress(status: string): boolean {
            return (status === 'WriteToFileComplete'
                    || status === 'EmptyData'
                    || status === 'ExecutionException'
                    || status.includes('Error'));
        }

        selectData(): [number[], number[], number[], number[]] {
            const selectSeasons: number[] = (this.$scheduleCalc.seasonSelected.length === 0 || (this.$scheduleCalc.seasonSelected.length === 1 && this.$scheduleCalc.seasonSelected[0] === 0))
                    ? []
                    // tslint:disable-next-line: no-non-null-assertion
                    : LocalData.filterNumberArrays(this.$scheduleCalc.seasonSelected)!!;
            const selectRegions: number[] = (this.$scheduleCalc.regionSelected.length === 0 || (this.$scheduleCalc.regionSelected.length && this.$scheduleCalc.regionSelected[0] === 0))
                    ? []
                    // tslint:disable-next-line: no-non-null-assertion
                    : LocalData.filterNumberArrays(this.$scheduleCalc.regionSelected)!!;
            const selectBuyerSegment: number[] = (this.$scheduleCalc.buyerSegmentsList.length === 0 || (this.$scheduleCalc.buyerSegmentsList.length && this.$scheduleCalc.buyerSegmentsList[0] === 0))
                    ? []
                    // tslint:disable-next-line: no-non-null-assertion
                    : LocalData.filterNumberArrays(this.$scheduleCalc.buyerSegmentsList)!!;
            const selectFormats: number[] = (this.$scheduleCalc.formatSelected.length === 0 || (this.$scheduleCalc.formatSelected.length && this.$scheduleCalc.formatSelected[0] === 0))
                    ? []
                    // tslint:disable-next-line: no-non-null-assertion
                    : LocalData.filterNumberArrays(this.$scheduleCalc.formatSelected)!!;
            return [selectSeasons, selectRegions, selectBuyerSegment, selectFormats];
        }

        initTask() {
            if (this.$scheduleCalc.selectMarket.id === -1) {
                return;
            }
            (this.$refs.updateRegionsRef as any).toggleLoading(true);
            (this.$refs.updateSeasonsRef as any).toggleLoading(true);
            (this.$refs.updateBuyerSegmentsRef as any).toggleLoading(true);
            (this.$refs.formatSelectedRef as any).toggleLoading(true);
            (this.$refs.groupSelectedRef as any).toggleLoading(true);
            (this.$refs.clasterSelectedRef as any).toggleLoading(true);
            (this.$refs.groupOfProductRef as any).toggleLoading(true);
            (this.$refs.subcategoriesRef as any).toggleLoading(true);
            (this.$refs.productSegmentsRef as any).toggleLoading(true);

            this.$scheduleCalc.categoriesOfProduct = [];
            this.$scheduleCalc.clusterSelected = [];
            this.$scheduleCalc.formatSelected = [];
            this.$scheduleCalc.groupsOfProduct = [];
            this.$scheduleCalc.subcategories = [];
            this.$scheduleCalc.productSegments = [];
            this.taskInfo.storeFormatOptions = [];
            this.taskInfo.storeRegionOptions = [];
            this.taskInfo.buyerSegmentOptions = [];
            this.taskInfo.categoryOptions = [];
            this.taskInfo.clusterOptions = [];
            this.taskInfo.psegemnts = [];
            this.taskInfo.subcategories = [];
            this.taskInfo.groupsOfProduct = [{value: null, label: this.$t('regular.common.all') as string}];
            const self = this;
            this.getCategoryInfo(() => {
                self.loadProductsGroup();
                self.getRegionInfo();
                self.getFormatInfo();
                self.getBuyerSegment();
                self.getClusterInfo();
                self.loadProductsSubcategories();
                self.loadProductSegments();
            });
        }

        loadProductsGroup() {
            this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.group))
                    .then((data) => {
                        const filterData = data.data;
                        setTimeout(() => {
                            (this.$refs.groupOfProductRef as any).toggleLoading(false);
                        }, 250);
                        this.taskInfo.groupsOfProduct = filterData.groups.map((i) => {
                            return {value: i.id, label: i.name}
                        });
                        this.taskInfo.groupsOfProduct.unshift({value: 0, label: this.$t('regular.common.all') as string});
                    })
                    .catch((e) => {
                    })
        }

        loadProductsSubcategories() {
            this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.subcategory))
                    .then((data) => {
                        const filterData = data.data;
                        setTimeout(() => {
                            (this.$refs.subcategoriesRef as any).toggleLoading(false);
                        }, 250);
                        this.taskInfo.subcategories = filterData.subcategories.map((i) => {
                            return {value: i.id, label: i.name}
                        });
                        this.taskInfo.subcategories.unshift({value: 0, label: this.$t('regular.common.all') as string})
                    })
                    .catch((e) => {
                    })
        }

        getCategoryInfo(cb: any = null) {
            this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.category))
                    .then((data) => {
                        const filterData = data.data;
                        setTimeout(() => {
                            (this.$refs.groupSelectedRef as any).toggleLoading(false);
                            (this.$refs.updateSeasonsRef as any).toggleLoading(false);
                        }, 250);
                        this.taskInfo.categoryOptions = filterData.categories.map((i) => {
                            return {value: i.id, label: i.name}
                        });
                        this.taskInfo.categoryOptions.unshift();
                        if (typeof cb === 'function') {
                            cb();
                        }
                    })
                    .catch((e) => {
                    })
        }

        getRegionInfo() {
            this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.region))
                    .then((data) => {
                        const filterData = data.data;
                        setTimeout(() => {
                            (this.$refs.updateRegionsRef as any).toggleLoading(false);

                        }, 500);

                        this.taskInfo.storeRegionOptions = filterData.storeRegion.map((i) => {
                            return {value: i.id, label: i.name};
                        })
                        this.taskInfo.storeRegionOptions.unshift(this.defaultIntSelectBox[0]);
                    })
                    .catch((e) => {
                    });
        }

        getFormatInfo() {
            this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.format))
                    .then((data) => {
                        const filterData = data.data;
                        setTimeout(() => {
                            (this.$refs.formatSelectedRef as any).toggleLoading(false);
                        }, 500);
                        this.taskInfo.storeFormatOptions = filterData.storeFormat.map((i) => {
                            return {value: i.id, label: i.name};
                        });
                        this.taskInfo.storeFormatOptions.unshift(this.defaultIntSelectBox[0]);
                    })
                    .catch((e) => {
                    });
        }

        getBuyerSegment() {
            this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.buyer))
                    .then((data) => {
                        const filterData = data.data;
                        setTimeout(() => {
                            (this.$refs.updateBuyerSegmentsRef as any).toggleLoading(false);
                        }, 500);

                        this.taskInfo.buyerSegmentOptions = filterData.buyerSegments.map((i) => {
                            return {value: i.id, label: i.name};
                        });

                    })
                    .catch((e) => {
                    });
        }

        getClusterInfo() {
            this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.cluster))
                    .then((data) => {
                        const filterData = data.data;
                        setTimeout(() => {
                            (this.$refs.clasterSelectedRef as any).toggleLoading(false);
                        }, 500);

                        this.taskInfo.clusterOptions = filterData.storeCluster.map((i) => {
                            return {value: i.id, label: i.name};
                        });
                        this.taskInfo.clusterOptions.unshift(this.defaultIntSelectBox[0]);
                    })
                    .catch((e) => {
                    });
        }

        loadProductSegments() {
            this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.p_segemnt))
                    .then((data) => {
                        const filterData = data.data;
                        setTimeout(() => {
                    (this.$refs.productSegmentsRef as any).toggleLoading(false);
                }, 250);
                        this.taskInfo.psegemnts = filterData.psegments.map((i) => {
                            return {
                                label: i.name,
                                value: i.id,
                            }
                        });
                        this.taskInfo.psegemnts.unshift({ value: 0, label: this.$t('regular.common.all') as string });
                    })
                    .catch((e) => {
                    });
        }

        calc() {
            if (this.$scheduleCalc.selectMarket.id <= 0) {
                this.showError(this.$t('regular.notifications.tradingCompanyNotSelected') as string);
                return;
            }
            const filters = this.getCalcFilter();
            if (LocalData.filterNumberArrays(filters.groupsOfProduct, true) == null
                    && LocalData.filterNumberArrays(filters.categories, true) == null) {
                (this.$refs.confirmPackageCalc as any).show();
                return;
            } else {
                this.savePackageSchedule();
                this.httpAddPackageCalcTask(filters)
                        .then((r) => {
                                    this.$log.debug('Create task', r.data);
                                    this.showInfo(this.$t('regular.notifications.calcStarted') as string);
                                },
                        )
                        .catch((e) => {
                            this.showError(this.$t('regular.errors.startCalcFailed') as string);
                        });
            }
        }

        saveEditableSchedule(id: number) {
            if (this.individualScheduleParams[id] === undefined) {
                this.individualScheduleParams[id] = {};
            }
            const config = this.individualScheduleParams[id];
            this.httpSaveScheduleIndividualCalc(config, id)
                    .then((r) => {
                                this.showInfo(this.$t('regular.notifications.scheduleIndivParamsSaved') as string);
                                this.refreshScheduleReports()
                            },
                    )
                    .catch((e) => {
                        this.showError(this.$t('regular.errors.saveScheduleIndivParamsFailed') as string);
                    });
        }

        deleteSchedule(scheduleId: number) {
            this.httpDeleteScheduleCalc(scheduleId)
                    .then((r) => {
                                this.showInfo(this.$t('regular.notifications.scheduleCalcDeleted') as string);
                                this.needLoadFiltersForTable = true;
                                this.refreshScheduleReports()
                            },
                    )
                    .catch((e) => {
                        this.showError(this.$t('regular.errors.deleteScheduleCalcFailed') as string);
                    });
        }

        setSchedulePeriodIndividConfig(individualScheduleParams: ConfigScheduleCalcMap<ScheduleIndividualConfigs>, id: number, property: keyof ScheduleIndividualConfigs, selectedPeriod: string) {
            if (typeof individualScheduleParams[id] === 'undefined') {
                individualScheduleParams[id] = {}
            }
            individualScheduleParams[id][property] = selectedPeriod
        }

        setScheduleDateIndividConfig(individualScheduleParams: ConfigScheduleCalcMap<ScheduleIndividualConfigs>, id: number, property: keyof ScheduleIndividualConfigs, date: string) {
            if (typeof individualScheduleParams[id] === 'undefined') {
                individualScheduleParams[id] = {}
            }
            individualScheduleParams[id][property] = date
        }

        setScheduleTimeoutOrPriorityIndividConfig(individualScheduleParams: ConfigScheduleCalcMap<ScheduleIndividualConfigs>, id: number, property: keyof ScheduleIndividualConfigs, timeoutOrPriority: number) {
            if (typeof individualScheduleParams[id] === 'undefined') {
                individualScheduleParams[id] = {}
            }
            individualScheduleParams[id][property] = timeoutOrPriority
        }

        clearScheduleFilters() {
            this.selectTradingFilter = this.defaultFilterValue;
            this.traidingsFilterOptions = []
            this.selectCategoryFilter = this.defaultFilterValue;
            this.categoryFilterOptions = []
            this.selectGroupFilter = this.defaultFilterValue;
            this.groupFilterOptions = []
            this.selectSubcategoryFilter = this.defaultFilterValue;
            this.subcategoryFilterOptions = []
            this.selectFormatFilter = this.defaultFilterValue;
            this.formatFilterOptions = []
            this.selectRegionFilter = this.defaultFilterValue;
            this.regionFilterOptions = []
            this.selectClusterFilter = this.defaultFilterValue;
            this.clusterFilterOptions = []
            this.needLoadFiltersForTable = true;
            this.refreshScheduleReports()
        }

        saveSchedule() {
            if (this.$scheduleCalc.selectMarket.id <= 0) {
                this.showError(this.$t('regular.notifications.tradingCompanyNotSelected') as string);
                return;
            }
            const scheduleParams = this.getCalcScheduleFilter();
            this.httpIdenticalCheckScheduleCalc(scheduleParams)
                    .then((r) => {
                                if (r.data > 0) {
                                    this.showAction(
                                            this.$t('regular.confirm.overwriteSchedule') as string,
                                            {
                                                position: 'top-center',
                                                type: 'info',
                                                singleton: true,
                                                duration: 10000,
                                                icon: 'check',
                                                theme: 'bubble',
                                                action: [{
                                                    text: this.$t('regular.common.yes') as string,
                                                    onClick: () => {
                                                        this.scheduleCalcId = r.data
                                                        this.isScheduleCross = false
                                                        this.httpSaveScheduleCalc(scheduleParams, this.scheduleCalcId, this.isScheduleCross)
                                                                .then((response) => {
                                                                            this.showInfo(this.$t('regular.notifications.scheduleCalcSaved') as string);
                                                                            this.needLoadFiltersForTable = true;
                                                                            this.refreshScheduleReports();
                                                                        },
                                                                )
                                                                .catch((ex) => {
                                                                    this.showError(this.$t('regular.errors.saveScheduleFailed') as string);
                                                                });
                                                    },
                                                }],
                                            });
                                } else {
                                    this.httpCrossCheckScheduleCalc(scheduleParams)
                                            .then((resp) => {
                                                        if (resp.data > 0) {
                                                            this.responseId = resp.data
                                                            this.calcWithScheduleCrossForModal = true
                                                        } else {
                                                            this.scheduleCalcId = resp.data
                                                            this.isScheduleCross = true
                                                            this.httpSaveScheduleCalc(scheduleParams, this.scheduleCalcId, this.isScheduleCross)
                                                                    .then((response) => {
                                                                                this.showInfo(this.$t('regular.notifications.scheduleCalcSaved') as string);
                                                                                this.needLoadFiltersForTable = true
                                                                                this.refreshScheduleReports();
                                                                            },
                                                                    )
                                                                    .catch((ex) => {
                                                                        this.showError(this.$t('regular.errors.saveScheduleFailed') as string);
                                                                    });
                                                        }
                                                    },
                                            )
                                            .catch((e) => {
                                                this.showError(this.$t('regular.errors.saveScheduleFailed') as string);
                                            });
                                }
                            },
                    )
        }

        saveCrossSchedule() {
            const scheduleParams = this.getCalcScheduleFilter();
            this.scheduleCalcId = this.responseId
            this.isScheduleCross = true
            this.httpSaveScheduleCalc(scheduleParams, this.scheduleCalcId, this.isScheduleCross)
                    .then((response) => {
                                this.showInfo(this.$t('regular.notifications.scheduleCalcSaved') as string);
                                this.needLoadFiltersForTable = true;
                                this.refreshScheduleReports();
                            },
                    )
                    .catch((ex) => {
                        this.showError(this.$t('regular.errors.saveScheduleFailed') as string);
                    });
        }

        fetchScheduleCalcList(ctx: any, callback: (items: any[]) => void) {
            const smallFilter = this.getSmallScheduleFilter()
            const offset = (ctx.currentPage - 1) * this.scheduleCalcLimit;
            this.httpGetSavedScheduleReports(smallFilter, this.scheduleCalcLimit, offset)
                    .then((r) => {
                                this.scheduleCalcTableRows = r.data.content.filter((it) => it.kviCartId === undefined);
                                this.scheduleCalcTableRows.forEach((column, index) => {
                                    column.key = column.id
                                    column.startDate = moment(new Date(column.startDate)).format('YYYY-MM-DD')
                                    column.endDate = moment(new Date(column.endDate)).format('YYYY-MM-DD')
                                });

                                if (this.needLoadFiltersForTable) {
                                    let ids = this.scheduleCalcTableRows.map((it) => it.id);
                                    this.httpGetAllFiltersInScheduleReports(ids)
                                            .then((response) => {
                                                        const result = response.data

                                                        const categories = result.categories.filter((i) => {
                                                            return i.name !== '';
                                                        });
                                                        this.categoryFilterOptions = categories.map((i) => {
                                                            return {value: i.id, label: i.name};
                                                        });
                                                        const groups = result.groupsOfProduct.filter((i) => {
                                                            return i.name !== '';
                                                        });
                                                        this.groupFilterOptions = groups.map((i) => {
                                                            return {value: i.id, label: i.name};
                                                        });
                                                        const subcategories = result.subcategories.filter((i) => {
                                                            return i.name !== '';
                                                        });
                                                        this.subcategoryFilterOptions = subcategories.map((i) => {
                                                            return {value: i.id, label: i.name};
                                                        });
                                                        const storeFormat = result.storeFormat.filter((i) => {
                                                            return i.name !== '';
                                                        });
                                                        this.formatFilterOptions = storeFormat.map((i) => {
                                                            return {value: i.id, label: i.name};
                                                        });
                                                        const regions = result.storeRegionValues.filter((i) => {
                                                            return i.name !== '';
                                                        });
                                                        this.regionFilterOptions = regions.map((i) => {
                                                            return {value: i.id, label: i.name};
                                                        });
                                                        const clusters = result.storeCluster.filter((i) => {
                                                            return i.name !== '';
                                                        });
                                                        this.clusterFilterOptions = clusters.map((i) => {
                                                            return {value: i.id, label: i.name};
                                                        });

                                                        result.tradingName.forEach((i) => {
                                                            this.newScheduleCalcTableFields[6].filters.push({value: i.id, label: i.name});
                                                        });
                                                        groups.forEach((i) => {
                                                            this.newScheduleCalcTableFields[7].filters.push({value: i.id, label: i.name});
                                                        });
                                                        categories.forEach((i) => {
                                                            this.newScheduleCalcTableFields[8].filters.push({value: i.id, label: i.name});
                                                        });
                                                        subcategories.forEach((i) => {
                                                            this.newScheduleCalcTableFields[9].filters.push({value: i.id, label: i.name});
                                                        });
                                                        storeFormat.forEach((i) => {
                                                            this.newScheduleCalcTableFields[10].filters.push({value: i.id, label: i.name});
                                                        });
                                                        regions.forEach((i) => {
                                                            this.newScheduleCalcTableFields[11].filters.push({value: i.id, label: i.name});
                                                        });
                                                        clusters.forEach((i) => {
                                                            this.newScheduleCalcTableFields[12].filters.push({value: i.id, label: i.name});
                                                        });

                                                        this.traidingsFilterOptions.unshift(this.defaultFilterValue);
                                                        this.categoryFilterOptions.unshift(this.defaultFilterValue);
                                                        this.groupFilterOptions.unshift(this.defaultFilterValue);
                                                        this.subcategoryFilterOptions.unshift(this.defaultFilterValue);
                                                        this.formatFilterOptions.unshift(this.defaultFilterValue);
                                                        this.regionFilterOptions.unshift(this.defaultFilterValue);
                                                        this.clusterFilterOptions.unshift(this.defaultFilterValue);

                                                        this.needLoadFiltersForTable = false;
                                                    },
                                            )
                                            .catch((ex) => {
                                                this.showError(this.$t('regular.errors.loadScheduleFiltersFailed') as string);
                                            });
                                }

                                const pagination = { ...this.pagination };
                                pagination.total = r.data.totalElements;
                                this.pagination = pagination;
                                this.scheduleCalcTotalRows = r.data.totalElements;
                                callback(r.data.content);
                            },
                    )
                    .catch((e) => {
                        callback([]);
                    });
        }

        timeOutValidate(timeout: number): boolean {
            return timeout > 0;
        }

        priorityValidate(priority: number): boolean {
            return priority > 0;
        }

        onMultiSelectToggle(open: boolean) {
        this.dropDownOpen = open;
        if (!open) {
            if (this.onDropdownClosed != null) {
                this.onDropdownClosed.apply(open);
                this.onDropdownClosed = null;
            }
        }
    }

    showOptimizationPriceStrategy(): boolean {
        return this.$scheduleCalc.compensateLowerTargets && this.$scheduleCalc.compensateAllCategories != null && this.$scheduleCalc.compensateAllCategories;
    }

        private getTaskInfo(taskType: TaskInfoFilterType): GetTaskInfo {
            const [, selectRegions, , selectFormats] = this.selectData();
            return {
                type: taskType,
                tradingId: this.$scheduleCalc.selectMarket.id,
                categories: LocalData.filterNumberArrays(this.$scheduleCalc.categoriesOfProduct),
                groups: LocalData.filterNumberArrays(this.$scheduleCalc.groupsOfProduct),
                subcategory: LocalData.filterNumberArrays(this.$scheduleCalc.subcategories, true),
                productSegments: LocalData.filterNumberArrays(this.$scheduleCalc.productSegments),
                segments: null,
                storeFormat: selectFormats,
                storeCluster: this.$scheduleCalc.clusterSelected,
                storeRegion: selectRegions,
                byReports: false,
            }
        }

        private getCalcFilter(): PackageCalcConfig {
            // tslint:disable-next-line: no-non-null-assertion
            let groups = LocalData.filterNumberArrays(this.$scheduleCalc.groupsOfProduct)!!;
            // Если не выбрали ни одной группы и оставили опцию "Все"
            if (groups.length === 0) {
                groups = this.taskInfo.groupsOfProduct.map((group) => {
                    // tslint:disable-next-line: no-non-null-assertion
                    return group.value!!
                });
                // Удаляем из массива опцию "Все"
                groups.splice(0, 1)
            }
            const [selectSeasons, selectRegions, selectBuyerSegment, selectFormats] = this.selectData();
            const selectClusters: number[] = (this.$scheduleCalc.clusterSelected.length === 0 || (this.$scheduleCalc.clusterSelected.length && this.$scheduleCalc.clusterSelected[0] === 0))
                    // tslint:disable-next-line: no-non-null-assertion
                    ? [] : LocalData.filterNumberArrays(this.$scheduleCalc.clusterSelected)!!;
            const sendReportToFtp = this.$scheduleCalc.sendReportToFtp;
            return {
                coefficientK1: this.$scheduleCalc.selectCoefficent.value.k1,
                coefficientK2: this.$scheduleCalc.selectCoefficent.value.k2,
                // tslint:disable-next-line: no-non-null-assertion
                categories: LocalData.filterNumberArrays(this.$scheduleCalc.categoriesOfProduct)!!,
                storeCluster: selectClusters,
                seasonValues: selectSeasons,
                buyerSegments: selectBuyerSegment,
                storeRegionValues: selectRegions,
                storeFormat: selectFormats,
                tradingId: this.$scheduleCalc.selectMarket.id,
                calculationDay: +this.$scheduleCalc.calculationDay,
                // tslint:disable-next-line: no-non-null-assertion
                groupsOfProduct: groups,
                // tslint:disable-next-line: no-non-null-assertion
                priceOpt: this.$scheduleCalc.selectCoefficent.value.enum!,
                subcategories: LocalData.filterNumberArrays(this.$scheduleCalc.subcategories),
                separateSubcategories: this.$scheduleCalc.separateSubcategories,
                separateClusters: this.$scheduleCalc.separateClusters,
                packageCalc: true,
                categoryStrategy: this.$scheduleCalc.categoryStrategy.value,
                sendReportToFtp,
                calcWithBatchNumber: true,
                backBasketPart: this.$scheduleCalc.backBasketPart,
                compensateAllCategories: this.$scheduleCalc.compensateAllCategories,
                thompsonSampling: this.$scheduleCalc.thompsonSampling,
                revaluationCalculateParams: this.$scheduleCalc.revaluationCalculateParams,
                applyOmnichannel: this.$scheduleCalc.applyOmnichannel,
                sendGeneralReportNotification: localStorage.getItem('sendGeneratedReportNotification') === 'true',
                isFixPricePromo: this.$scheduleCalc.isFixPricePromo,
                useSkuRotation: false,
                useFixedPrices: true,
                autoApprovalParams: this.$scheduleCalc.autoApprovalParams,
            };
        }

        private getCalcScheduleFilter(): ScheduleCalcFilter {
            const [selectSeasons, selectRegions, selectBuyerSegment, selectFormats] = this.selectData();
            const selectClusters: number[] = (this.$scheduleCalc.clusterSelected.length === 0 || (this.$scheduleCalc.clusterSelected.length && this.$scheduleCalc.clusterSelected[0] === 0))
                    // tslint:disable-next-line: no-non-null-assertion
                    ? [] : LocalData.filterNumberArrays(this.$scheduleCalc.clusterSelected)!!;
            const sendReportToFtp = this.$scheduleCalc.sendReportToFtp;
            return {
                coefficientK1: this.$scheduleCalc.selectCoefficent.value.k1,
                coefficientK2: this.$scheduleCalc.selectCoefficent.value.k2,
                // tslint:disable-next-line: no-non-null-assertion
                categories: LocalData.filterNumberArrays(this.$scheduleCalc.categoriesOfProduct)!!,
                productSegments: LocalData.filterNumberArrays(this.$scheduleCalc.productSegments)!!,
                storeCluster: selectClusters,
                seasonValues: selectSeasons,
                buyerSegments: selectBuyerSegment,
                storeRegionValues: selectRegions,
                storeFormat: selectFormats,
                tradingId: this.$scheduleCalc.selectMarket.id,
                calculationDay: +this.$scheduleCalc.calculationDay,
                // tslint:disable-next-line: no-non-null-assertion
                groupsOfProduct: LocalData.filterNumberArrays(this.$scheduleCalc.groupsOfProduct)!!,
                // tslint:disable-next-line: no-non-null-assertion
                priceOpt: this.$scheduleCalc.selectCoefficent.value.enum!,
                subcategories: LocalData.filterNumberArrays(this.$scheduleCalc.subcategories),
                separateSubcategories: this.$scheduleCalc.separateSubcategories,
                separateClusters: this.$scheduleCalc.separateClusters,
                packageCalc: true,
                categoryStrategy: this.$scheduleCalc.categoryStrategy.value,
                sendReportToFtp,
                startDate: this.startScheduleDate,
                endDate: this.endScheduleDate,
                schedulePeriod: this.selectSchedulePeriod.value,
                priority: this.schedulePriority,
                timeout: this.scheduleTimeout,
                calcWithBatchNumber: true,
                backBasketPart: this.$scheduleCalc.backBasketPart,
                compensateAllCategories: this.$scheduleCalc.compensateAllCategories,
                thompsonSampling: this.$scheduleCalc.thompsonSampling,
                revaluationCalculateParams: this.$scheduleCalc.revaluationCalculateParams,
                applyOmnichannel: this.$scheduleCalc.applyOmnichannel,
                sendGeneralReportNotification: localStorage.getItem('sendGeneratedReportNotification') === 'true',
                isFixPricePromo: this.$scheduleCalc.isFixPricePromo,
                useSkuRotation: false,
                kviCartId: null,
                kviCartName: null,
                useFixedPrices: true,
                autoApprovalParams: this.$scheduleCalc.autoApprovalParams,
            };
        }

        private getSmallScheduleFilter(): SmallScheduleListFilter {
            return {
                tradingId: this.newSelectTradingFilter,
                categories: this.newSelectCategoryFilter === this.defaultFilterValue.value ? [] : [this.newSelectCategoryFilter],
                groupsOfProduct: this.newSelectGroupFilter === this.defaultFilterValue.value ? [] : [this.newSelectGroupFilter],
                subcategories: this.newSelectSubcategoryFilter === this.defaultFilterValue.value ? [] : [this.newSelectSubcategoryFilter],
                storeFormat: this.newSelectFormatFilter,
                storeRegionValues: this.newSelectRegionFilter === this.defaultFilterValue.value ? [] : [this.newSelectRegionFilter],
                storeCluster: this.newSelectClusterFilter === this.defaultFilterValue.value ? [] : [this.newSelectClusterFilter],
                kviCartId: null,
                kviCartName: null,
            };
        }

        get calculationDayValidate(): boolean {
            return this.$scheduleCalc.calculationDay > 0;
        }

        get isAdmin(): boolean {
            return this.$userRole === UserRole.ROLE_ADMIN;
        }

        get isGroupsSelected(): boolean {
            const groups = LocalData.filterNumberArrays(this.$scheduleCalc.groupsOfProduct);
            return groups != null && groups.length > 0;
        }

        get backBasketPartValidate(): boolean {
            if (this.$scheduleCalc.backBasketPart != null) {
                return this.$scheduleCalc.backBasketPart >= 0 && this.$scheduleCalc.backBasketPart <= 100;
            }
            return false;
        }

        get isCategoriesSelected(): boolean {
            const categories = LocalData.filterNumberArrays(this.$scheduleCalc.categoriesOfProduct);
            return categories != null && categories.length > 0;
        }

        get isSubcategorySelected(): boolean {
        const subcategories = LocalData.filterNumberArrays(this.$scheduleCalc.subcategories);
        return subcategories != null && subcategories.length!! > 0;
    }

        private get isFormatSelected(): boolean {
            const formats =this.$scheduleCalc.formatSelected;
            return formats != null && formats.length > 0;
        }

        private get isRegionsSelected(): boolean {
            const regions = this.$scheduleCalc.regionSelected;
            return regions != null && regions.length > 0;
        }

        private get isClustersSelected(): boolean {
            const clusters = this.$scheduleCalc.clusterSelected;
            return clusters != null && clusters.length > 0;
        }

    }
